import React, { useEffect, useState } from "react";
import { API_URL, authFetch, parseJsonResponse, responseErrorMessage } from "../../utils/auth";
import { features } from "../../utils/features";

export default function NotificationsCard() {
  const [preferences, setPreferences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    async function loadPreferences() {
      setLoading(true);
      setError("");
      try {
        const res = await authFetch(`${API_URL}/notification-preferences/`);
        const data = await parseJsonResponse(res);
        if (!res.ok) throw new Error(responseErrorMessage(res, data, "Unable to load notification preferences."));
        if (active) setPreferences((data?.results || []).filter((option) => features.meetingsEnabled || option.key !== "meeting_updates"));
      } catch (err) {
        if (active) setError(err.message || "Unable to load notification preferences.");
      } finally {
        if (active) setLoading(false);
      }
    }
    loadPreferences();
    return () => { active = false; };
  }, []);

  async function togglePreference(option) {
    const nextEnabled = !option.enabled;
    setSavingKey(option.key);
    setError("");
    setPreferences((current) => current.map((item) => item.key === option.key ? { ...item, enabled: nextEnabled } : item));
    try {
      const res = await authFetch(`${API_URL}/notification-preferences/`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ preferences: { [option.key]: nextEnabled } }),
      });
      const data = await parseJsonResponse(res);
      if (!res.ok) throw new Error(responseErrorMessage(res, data, "Unable to save notification preference."));
      setPreferences((data?.results || []).filter((item) => features.meetingsEnabled || item.key !== "meeting_updates"));
    } catch (err) {
      setError(err.message || "Unable to save notification preference.");
      setPreferences((current) => current.map((item) => item.key === option.key ? { ...item, enabled: option.enabled } : item));
    } finally {
      setSavingKey("");
    }
  }

  return (
    <div className="settings-card notifications-card">
      <div className="settings-card-heading">
        <h3>Notifications</h3>
        <p>Choose which portal updates should reach you.</p>
      </div>

      {error && <p className="settings-inline-error">{error}</p>}
      {loading ? <p className="hint">Loading notification preferences...</p> : (
        <div className="settings-toggle-list">
          {preferences.map((option) => (
            <label className="settings-toggle" key={option.key}>
              <span>
                <strong>{option.label}</strong>
                <small>{option.description}</small>
              </span>
              <input type="checkbox" checked={option.enabled} disabled={savingKey === option.key} onChange={() => togglePreference(option)} aria-label={option.label} />
            </label>
          ))}
        </div>
      )}
    </div>
  );
}



